import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminHoleResultsStore } from './store';

export interface IAdminHoleResultsActions {
  get: (
    roundId: number,
    force?: boolean
  ) => { adminHoleResults?: IAdminHoleResultsStore; errors?: IErrorsStore };
  save: (groupId: number, scores: any) => any;
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, force?: boolean) => {
    if (state.adminHoleResults[roundId] && !force) {
      return {
        adminHoleResults: state.adminHoleResults
      };
    }

    const response = await request.get(api.results('staff', 'holes', { round_id: roundId }));

    if (response.error) {
      return {
        errors: {
          adminHoleResults: { msg: 'Error retrieving the Round Format Awards by Holes List.' }
        }
      };
    }

    return {
      adminHoleResults: {
        ...state.adminHoleResults,
        [roundId]: response
      }
    };
  },
  save: async (state: IStore, groupId: number, data: any) => {
    const response = await request.patch(`${api.group(groupId)}scores`, {
      instances: Object.values(data)
    });

    if (response.error) {
      return { errors: { games: { msg: 'Error updating the scores.' } } };
    }

    return state;
  }
};

export default actions;
